export const DataRangeService = Symbol.for('DataRangeService');
